<footer class="footer-main">
  <div class="footer-links-div">
    <button
      type="button"
      class="footer-link-button"
      (click)="onAccessibility($event)"
      aria-label="Accessibility statement dialog">
      Accessibility
    </button>
    <span class="footer-link-separator" aria-hidden="true">|</span>
    <a
      href="https://healthy.kaiserpermanente.org/privacy"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Website Privacy - opens in new window">
      Website Privacy
    </a>
    <span class="footer-link-separator" aria-hidden="true">|</span>
    <a href="#" target="_self" (click)="onPrivacyChoices($event)" aria-label="Your Privacy Choices">
      Your Privacy Choices
    </a>
    <span class="footer-link-separator" aria-hidden="true">|</span>
    <a
      href="https://healthy.kaiserpermanente.org"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="kp.org - opens in new window">
      kp.org
    </a>
    <span class="footer-link-separator" aria-hidden="true">|</span>
    <a
      href="https://healthy.kaiserpermanente.org/community-providers"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Provider portal - opens in new window">
      Provider portal
    </a>
    <span class="footer-link-separator" aria-hidden="true">|</span>
    <a
      href="https://healthy.kaiserpermanente.org/georgia/pages/securepages/profile/data-sharing-authorization/third-party-access"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Member Access Portal - opens in new window">
      Member Access Portal
    </a>
  </div>
  <div class="footer-text-div">
    <p class="footer-bottom-text">Adobe Acrobat Reader is required to read PDFs.</p>

    <p class="footer-bottom-text">© {{ currentYear }} Kaiser Foundation Health Plan, Inc.</p>
  </div>
</footer>
